export default __webpack_public_path__ + "resources/icons/d332-ca0b.webp";